import { Button } from '@chakra-ui/react'
import { Link as RouterLink } from 'react-router-dom'
import { FiChevronLeft } from 'react-icons/fi'

/** [CF-1 P3] The way back to the Today picker, shown only when the canvasser has 2+ assignments. */
export function TodayBackLink() {
  return (
    <Button asChild variant="ghost" minH="44px" px={1} flexShrink={0}>
      <RouterLink to="/canvasser/today"><FiChevronLeft aria-hidden />Today</RouterLink>
    </Button>
  )
}
